// The Maps script can only be loaded once per page session, so every page that uses
// LoadScript must pass the same key and libraries.
export const GOOGLE_MAPS_API_KEY = 'AIzaSyCPhSP57_v3UIrDN-9EAB8uXoa6m4pHhr0';
export const GOOGLE_MAPS_LIBRARIES = ['places'];
